import { Condition, State } from "@/services/backend/deliveries/state/state";
import { EvaluableType } from "@/services/backend/sample-error/sample-error";
import {
  Testnorm,
  GrowthMedium,
  ProcedureType,
  SampleType,
  SamplingMethod,
} from "@/services/backend/types";

export const sampleTypes: { [key: string]: string } = {
  [SampleType.AirMicrobial]: "LK",
  [SampleType.SurfaceMicrobial]: "AK",
};

export const samplingMethods: { [key: string]: string } = {
  [SamplingMethod.aLK]: "aLK",
  // [SamplingMethod.pLK]: "pLK",
  [SamplingMethod.AK]: "AK",
};

export const procedureTypes: { [key: string]: string } = {
  [ProcedureType.RLT1N]: "1N-RLT",
  [ProcedureType.RLT2N]: "2N-RLT",
};

export const growthMedia: { [key: string]: string } = {
  [GrowthMedium.Caso]: "Caso",
  [GrowthMedium.Malt]: "Malz",
  [GrowthMedium.DG18]: "DG18",
};

export const evaluableTypes: { [key: string]: string } = {
  [EvaluableType.Evaluable]: "Auswertbar",
  [EvaluableType.NotEvaluable]: "Nicht auswertbar",
};

export const packageConditions: { [key: string]: string } = {
  [Condition.Fine]: "In Ordnung",
  [Condition.SlightlyDamaged]: "Leicht beschädigt",
  [Condition.HeavilyDamaged]: "Schwer beschädigt",
  [Condition.Rejected]: "Zurückgewiesen",
};

export const deliveryState: { [key: string]: string } = {
  [State.Announced]: "Angekündigt",
  [State.Delivered]: "Angekommen",
};

export const testnorm: { [key: string]: string } = {
  [Testnorm.VDI]: "VDI 6022-1: 2018-01",
  [Testnorm.DIN]: "DIN EN 17141: 2021-02",
  [Testnorm.EU]: "EU-GMP: 2022-08",
};

export const artefactLabel: { [key: string]: string } = {
  overview: "Übersicht",
  contact: "Ansprechpartner",
  delivery: "Lieferung",
  documentation: "Dokumentation",
  counting: "Zählung",
  differentiation: "Differenzierung",
  inspection: "Prüfberichte",
};
